import appConfig from '../config/appConfig';
import {showUsbRequiredModalAction} from '../state/ducks/modal';
import {dispatch} from '../state/store';
import connectivityService from './device/connectivityService';
import deviceTypesService from './device/deviceTypesService';
import appRouterService from './route/appRouterService';

const redirectToConnectionPage = ({type, productName}) => {
    if (!type) {
        return appRouterService.forwardToSelectDevice();
    }

    const isDeviceBleDisabled = deviceTypesService.isDeviceBleDisabledByType(type);
    const isUsbSupported = connectivityService.isUsbSupported();

    if (isDeviceBleDisabled && isUsbSupported) {
        connectivityService.setIsUsb();
        appRouterService.forwardToConnectionGuidePage({deviceType: type});
        return;
    }

    if (isDeviceBleDisabled) {
        dispatch(showUsbRequiredModalAction({deviceName: productName, deviceType: type}));
        return;
    }

    const isBleAndUsbSupported = connectivityService.isBleAndUsbSupported();

    if (isBleAndUsbSupported) {
        return appRouterService.forwardToConnectionSelectionPage({deviceType: type});
    }

    const isBleEnabled = appConfig.getConnectivityIsBle();

    if (!isBleEnabled) {
        connectivityService.setIsUsb();
        return appRouterService.forwardToConnectionGuidePage({deviceType: type});
    }

    return appRouterService.forwardToPairingGuidePage({deviceType: type});
};

export default {
    redirectToConnectionPage,
};
